import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaPlay, FaQuestionCircle, FaEllipsisH, FaThLarge, FaTrophy , FaTicketAlt } from 'react-icons/fa';
import './MobileBottomNav.css';

const LEFT_ITEMS = [
  { label: 'Home',  to: '/dashboard', icon: FaHome },
  { label: 'H2H',  to: '/h2h',       icon: FaTrophy },
];

const RIGHT_ITEMS = [
  { label: 'Betcodes',  to: '/bet-codes',      icon: FaTicketAlt },
  { label: 'Comp',  to: '/competitions',  icon: FaTrophy },
];

const MobileBottomNav = ({ quickOpen, onQuickToggle }) => {
  const { pathname } = useLocation();

  const isActive = (to) =>
    pathname === to || pathname.startsWith(`${to}/`);

  return (
    <nav className="mobile-nav">
      {/* Left pair */}
      <div className="mobile-nav-group">
        {LEFT_ITEMS.map(({ label, to, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className={`mobile-nav-item ${isActive(to) ? 'active' : ''}`}
          >
            <Icon className="mobile-nav-icon" />
            <span className="mobile-nav-label">{label}</span>
          </Link>
        ))}
      </div>

      {/* Center FAB with curved notch (SVG handles the curve) */}
      <div className="mobile-nav-center">
        <button
          className={`mobile-fab ${quickOpen ? 'open' : ''}`}
          onClick={onQuickToggle}
          type="button"
          aria-label={quickOpen ? 'Close quick actions' : 'Open quick actions'}
        >
          <FaThLarge />
        </button>
      </div>

      {/* Right pair */}
      <div className="mobile-nav-group">
        {RIGHT_ITEMS.map(({ label, to, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className={`mobile-nav-item ${isActive(to) ? 'active' : ''}`}
          >
            <Icon className="mobile-nav-icon" />
            <span className="mobile-nav-label">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;